export default __webpack_public_path__ + "static/media/script.708781ca.png";